import React, {useEffect, useState, useMemo} from 'react'
import _ from 'lodash'
import {Modal} from '@material-ui/core'

import {useGetGroupFiltersReducer} from '../../../state/groups/get-group-filters/reducer'
import {getGroupFilters} from '../../../state/groups/get-group-filters/actions'

import {
  createCalendarChildView,
  updateCalendarChildView,
} from '../../../state/calendar-views/post-calendar-child-view/actions'
import usePostCalendarChildViewReducer, {
  ActionTypes,
} from '../../../state/calendar-views/post-calendar-child-view/reducer'

import {deleteCalendarChildView} from '../../../state/calendar-views/delete-calendar-child-view/actions'
import useDeleteCalendarChildViewReducer from '../../../state/calendar-views/delete-calendar-child-view/reducer'

// Custom Components
import {ViewColor} from './ViewColor'

// styles
import './PopFilteredView.scss'
import {useModal} from '../../../common/Modal'
import {DatesToDisplay} from './PopGroupView/DatesToDisplay'
import {DisplayFields} from './PopGroupView/DisplayFields'
import {Select} from './PopGroupView/Select'
import {useTranslation} from 'react-i18next'
import useSearchEntityFieldTypesReducer from '../../../state/entities/search-entity-field-types/reducer'
import {searchEntityFieldTypes} from '../../../state/entities/search-entity-field-types/actions'
import {Filters} from './PopGroupView/Filters'
import clsx from 'clsx'

const PopFilteredView = ({open, data, groups, onClose, onSuccess, customColors = [], viewData}) => {
  const {t} = useTranslation()
  const simpleModal = useModal()

  const [filters, dispatch] = useGetGroupFiltersReducer()
  const [save, saveDispatch] = usePostCalendarChildViewReducer()
  const [remove, deleteDispatch] = useDeleteCalendarChildViewReducer()
  const [group, groupDispatch] = useSearchEntityFieldTypesReducer()
  const [refColorPicker, setRefColorPicker] = useState(null)
  const [filteredView, setFilteredView] = useState({
    // user_id: --,
    entity_id: -1,
    color: '#fe8787',
    groups: [],
    actions: [],
    filters: [],
    display_fields: [],
    name: '',
  })

  const [errors, setErrors] = useState({})

  const entity_view_ids = _.map(viewData, (val, key) => {
    return val.group_view.entity_id
  })

  // trigger load group data
  useEffect(() => {
    if (filteredView.entity_id !== undefined && filteredView.entity_id !== -1) {
      searchEntityFieldTypes(groupDispatch, filteredView.entity_id, {
        include_actions: false,
        include_related: true,
        field_types: ['DateField', 'DateFormulaField', 'CreatedAtField', 'DateTimeField'],
        currency_items: false,
        with_actions: true,
      })
    }
  }, [filteredView.entity_id, groupDispatch])

  // initialize for mounting
  useEffect(() => {
    setErrors({})
    if (!data) {
      setFilteredView({
        // user_id: --,
        entity_id: -1,
        color: '#fe8787',
        groups: [],
        actions: [],
        filters: [],
        display_fields: [],
        name: '',
      })
    } else {
      const _data = _.pick(data, [
        'user_id',
        'entity_id',
        'color',
        'filters',
        'name',
        'actions',
        'groups',
        'display_fields',
      ])
      if (data._id) {
        _data['id'] = data._id['$oid'] || data._id
      }
      if (!_data.groups) _data.groups = []
      if (!_data.actions) _data.actions = []
      setFilteredView({..._data})
    }
  }, [data, setFilteredView])

  //
  useEffect(() => {
    if (!_.isEmpty(group.data)) {
      const _groups = _.map(group.data.fields, f => ({
        field_id: f.id,
        key: f.key,
        active: false,
      }))
      const _actions = _.map(group.data.actions || [], a => ({
        action_id: a.id,
        active: false,
      }))

      setFilteredView(p => ({
        ...p,
        groups: _groups.map(g => p.groups.find(pg => pg.field_id === g.field_id) || g),
        actions: _actions.map(a => p.actions.find(pa => pa.action_id === a.action_id) || a),
      }))
    }
  }, [group.data])

  const update = (e, k, v) => {
    setFilteredView(p => ({...p, [k]: v}))
  }

  const resetErrors = () => {
    if (!_.isEmpty(errors)) {
      setErrors({})
    }
    if (!_.isEmpty(save.errors)) {
      saveDispatch({type: ActionTypes.RESET})
    }
  }

  const handleClickColorPicker = e => {
    setRefColorPicker(e.target)
  }

  const handleToggleGroup = (e, k, v) => {
    const _groups = [...filteredView.groups]
    _groups[k].active = v
    update(e, 'groups', _groups)
  }

  const handleToggleActions = (e, k, v) => {
    const _actions = [...filteredView.actions]
    _actions[k].active = v
    _actions[k].advance_option_key = {start_date: '', end_date: '', is_stamp: true}
    update(e, 'actions', _actions)
  }

  const handleSetActionAdvOpt = (e, k, v) => {
    const _actions = [...filteredView.actions]
    _actions[k].advance_option_key = v
    update(e, 'actions', _actions)
  }

  const handleSetDisplayFields = (e, v) => {
    update(e, 'display_fields', v)
  }

  const handleChangeFilters = (e, v) => {
    update(e, 'filters', v)
  }

  const handleClose = e => {
    resetErrors()
    onClose(e)
  }

  const handleChangeGroup = (e, item) => {
    resetErrors()
    update(e, 'entity_id', item.id)
    update(e, 'filters', [])
  }

  const handleConfirm = e => {
    // validate if has duplicate
    // get view data
    const _view = viewData.find(f => f.group_view.entity_id === filteredView.entity_id)
    if (!_view) return

    if (!filteredView.id && _view.group_view.calendar_child_view.length >= 10) {
      setErrors({name: ['You can only create maximum 10 filtered views per group.']})
      return
    }

    const nameMatched = _view.group_view.calendar_child_view.find(f => f.name === filteredView.name)
    if (
      nameMatched &&
      (!filteredView.id ||
        (filteredView.id && filteredView.id !== (nameMatched._id['$oid'] || nameMatched._id)))
    ) {
      setErrors({name: ['There is another filtered view with this name.']})
      return
    } else {
      setErrors({})
    }

    const _confirmFunc = !filteredView.id ? createCalendarChildView : updateCalendarChildView
    _confirmFunc(saveDispatch, {
      user_id: localStorage.user_id,
      ...filteredView,
    }).then(res => {
      onSuccess()
    })
  }

  const handleDelete = e => {
    if (simpleModal) {
      simpleModal.show({
        scheme: 'destructive',
        title: 'Delete Filtered View',
        description: 'Are you sure you want to delete this filtered view?',
        buttons: {
          affirmative: {
            label: 'Yes',
            click: (data, modal) => {
              deleteCalendarChildView(deleteDispatch, {
                user_id: localStorage.user_id,
                ...filteredView,
              }).then(res => {
                onSuccess()
              })
              modal.hide()
            },
          },
          negative: {
            label: 'No',
          },
        },
      })
    }
  }

  const handleChangeName = e => {
    resetErrors()
    update(e, 'name', e.target.value)
  }

  useEffect(() => {
    if (filteredView.entity_id !== undefined && filteredView.entity_id !== -1) {
      getGroupFilters(dispatch, {
        group_id: filteredView.entity_id,
        limit: 1,
        type: [
          'EntityListField',
          'ListField',
          'MultipleEntityListField',
          'MultipleListField',
          'ApUserField',
          'StatusField',
          'YesNoField',
        ].join(','),
      })
    }
  }, [dispatch, filteredView.entity_id])

  const combinedErrors = {...errors, ...save.errors}
  const isEdit = filteredView?.id ? true : false

  const disabledGroupsActions = useMemo(() => {
    if (filteredView.entity_id !== -1) {
      const fa = filteredView.actions
      const fg = filteredView.groups
      const g = viewData.find(f => f.group_view?.entity_id === filteredView.entity_id) || {}
      const ga = g.group_view?.actions || []
      const gg = g.group_view?.groups || []

      const a =
        fg.reduce((r, f) => {
          const _f = gg.find(ff => ff.field_id === f.field_id)
          if (!_f || !_f.active) {
            r.push(f.field_id)
          }
          return r
        }, []) || []
      const b =
        fa.reduce((r, f) => {
          const _f = ga.find(ff => ff.action_id === f.action_id)
          if (!_f || !_f.active) {
            r.push(f.action_id)
          }
          return r
        }, []) || []
      return {action_ids: b, group_ids: a}
    }
    return {action_ids: [], group_ids: []}
  }, [viewData, filteredView])

  return (
    <Modal
      style={{position: 'absolute'}}
      className={'ds-modal-wrapper'}
      open={open}
      onClose={onClose}
    >
      <div className="ds-modal-complex ds-modal-complex--lg ds-py-0">
        <div className="ds-flex-row ds-flex-no-spill">
          <div
            className="ds-flex-col ds-flex-no-spill ds-pt-24 ds-pb-20"
            style={{
              flex: '0 0 517px',
              borderRight: '1px solid #D6D8DC',
              paddingRight: 30,
            }}
          >
            <div
              className="ds-modal-header ds-mb-52"
              style={{display: 'flex', justifyContent: 'space-between'}}
            >
              <h4 className="ds-t400r">
                {!isEdit
                  ? t('calendar.filtered-view.add.title')
                  : t('calendar.filtered-view.edit.title')}
              </h4>

              <ViewColor value={filteredView.color} onChange={(e, v) => update(e, 'color', v)} />
            </div>
            <div className="ds-modal-body ds-flex-col ds-mb-32">
              <div className="ds-mb-12">
                <fieldset
                  className={clsx('ds-form-input', {
                    'ds-form-input--error': !!combinedErrors?.name?.length,
                  })}
                  required
                >
                  <legend>{t('calendar.filtered-view.add.txt-name')}</legend>
                  <input
                    className="ds-mr-8"
                    value={filteredView.name}
                    onChange={handleChangeName}
                  />
                </fieldset>
                <div className="ds-tip" hidden={!!!combinedErrors?.name?.length}>
                  <i className="ds-icon-error ds-tr100"></i>
                  <span>{combinedErrors?.name?.map(n => n)}</span>
                </div>
              </div>
              <Select
                disabled={isEdit}
                value={filteredView.entity_id}
                label={t('calendar.filtered-view.add.sel-group')}
                required
                placeholder={t('calendar.view.add.placeholder-select-field')}
                onChange={handleChangeGroup}
                items={groups.data}
                render={(item, index, clickHandle) => {
                  return (
                    <div
                      disabled={!entity_view_ids.includes(item.id)}
                      key={index}
                      onClick={e => clickHandle(e, item, index)}
                      className="ds-menu-item"
                    >
                      {item.name}
                    </div>
                  )
                }}
                selectedDisplay={(value, items) => _.find(items, f => f.id === value)?.name}
              />
              <DatesToDisplay
                entity_id={filteredView.entity_id}
                group={group}
                groups={filteredView.groups}
                disabledGroups={disabledGroupsActions.group_ids}
                disabledActions={disabledGroupsActions.action_ids}
                actions={filteredView.actions}
                handleToggleActions={handleToggleActions}
                handleToggleGroup={handleToggleGroup}
                handleSetActionAdvOpt={handleSetActionAdvOpt}
              />
            </div>
            <div className="ds-modal-footer" style={{height: 32, justifyContent: 'flex-start'}}>
              {isEdit && (
                <button className="ds-btn-destructive" onClick={handleDelete}>
                  {t('calendar.view.edit.btn-delete')}
                </button>
              )}
            </div>
          </div>
          {/* Right Section */}
          <div className="ds-flex-col ds-pt-48 ds-pb-20 ds-pl-30">
            <div className="ds-modal-body ds-mb-32 ds-flex-col" style={{gap: 24}}>
              <Filters
                groupView={filteredView}
                onChange={handleChangeFilters}
                setGroupView={setFilteredView}
              />
              <DisplayFields
                groupView={filteredView}
                onChange={handleSetDisplayFields}
                display_fields={filteredView.display_fields || []}
              />
            </div>

            <div className="ds-modal-footer">
              <button
                className="ds-btn-cta ds-mr-8"
                onClick={handleConfirm}
                disabled={
                  !_.isEmpty(combinedErrors) ||
                  filteredView.entity_id === -1 ||
                  filteredView.name === ''
                }
              >
                {!isEdit ? t('calendar.view.add.btn-create') : t('calendar.view.edit.btn-create')}
              </button>
              <button className="mdl-cancel ds-btn-secondary" onClick={handleClose}>
                {t('calendar.view.add.btn-cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PopFilteredView
